module.exports = __webpack_public_path__ + "img/no_list.12c8962a.png";